module.exports = __webpack_public_path__ + "img/img16.1392aab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img16.jpg
// module id = 312
// module chunks = 0